import ReduxHooks from '../store/ReduxHooks';
import { resetRewardAccount } from '../store/slices/RewardAccountSlice';

export const useCleanup = (): any => () => {
  ReduxHooks.dispatch(
    resetRewardAccount(),
  );
};
